/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignToCustomerRequestBody,
  AssignedDeviceResponseModel,
  AssignedInstallationsResponseModel,
  BadRequest,
  Conflict,
  Forbidden,
  GatewayResponseModel,
  InstallationLiveDataResponseModel,
  InternalServerError,
  NotFound,
  UnallocatedDeviceResponseModel,
  UnallocatedGatewayInstallationRequestModel,
  UnallocatedGatewayResponseModel,
  UnallocatedInstallationDeviceUpdateModel,
  UnallocatedInstallationsResponseModel,
  Unauthorized,
} from '../models';

export interface UnallocatedInstallationsAddGatewayDeviceRequest {
    unallocatedGatewayInstallationRequestModel: UnallocatedGatewayInstallationRequestModel;
}

export interface UnallocatedInstallationsAssignToCustomerRequest {
    installationId: string;
    assignToCustomerRequestBody: AssignToCustomerRequestBody;
}

export interface UnallocatedInstallationsDeleteInstallationRequest {
    installationId: string;
}

export interface UnallocatedInstallationsGetAllocatedLiveDataRequest {
    siteId: string;
}

export interface UnallocatedInstallationsGetAssignedInstallationDevicesRequest {
    siteId: string;
}

export interface UnallocatedInstallationsGetAssignedInstallationsRequest {
    page?: number;
    limit?: number;
    customerName?: string;
    customerEmail?: string;
}

export interface UnallocatedInstallationsGetLiveDataRequest {
    installationId: string;
}

export interface UnallocatedInstallationsGetUnallocatedInstallationDevicesRequest {
    installation: string;
}

export interface UnallocatedInstallationsGetUnallocatedInstallationGatewaysRequest {
    installation: string;
}

export interface UnallocatedInstallationsGetUnallocatedInstallationsRequest {
    page?: number;
    limit?: number;
    startCode?: string;
    tenantId?: string;
    installerId?: string;
    installerCompanyId?: string;
}

export interface UnallocatedInstallationsScanGatewayDevicesRequest {
    installationId: string;
    gatewayId: string;
}

export interface UnallocatedInstallationsUpdateDeviceConfigurationRequest {
    installationId: string;
    id: string;
    unallocatedInstallationDeviceUpdateModel: UnallocatedInstallationDeviceUpdateModel;
}

/**
 * 
 */
export class UnallocatedInstallationsApi extends runtime.BaseAPI {

    /**
     * Creates a new unallocated gateway installation configuration in the system. The gateway can be discovered and later assigned to a customer during installation process. Validates gateway serial number and vendor compatibility
     * Add Unallocated Gateway Installation
     */
    async unallocatedInstallationsAddGatewayDeviceRaw(requestParameters: UnallocatedInstallationsAddGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnallocatedGatewayResponseModel>> {
        if (requestParameters.unallocatedGatewayInstallationRequestModel === null || requestParameters.unallocatedGatewayInstallationRequestModel === undefined) {
            throw new runtime.RequiredError('unallocatedGatewayInstallationRequestModel','Required parameter requestParameters.unallocatedGatewayInstallationRequestModel was null or undefined when calling unallocatedInstallationsAddGatewayDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/gateway`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unallocatedGatewayInstallationRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new unallocated gateway installation configuration in the system. The gateway can be discovered and later assigned to a customer during installation process. Validates gateway serial number and vendor compatibility
     * Add Unallocated Gateway Installation
     */
    async unallocatedInstallationsAddGatewayDevice(requestParameters: UnallocatedInstallationsAddGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnallocatedGatewayResponseModel> {
        const response = await this.unallocatedInstallationsAddGatewayDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns an unallocated installation to a specific customer by customer ID or email, moving it from the unallocated pool to customer installations. This action links all associated devices and gateways to the customer account
     * Assign Installation to Customer
     */
    async unallocatedInstallationsAssignToCustomerRaw(requestParameters: UnallocatedInstallationsAssignToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GatewayResponseModel>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling unallocatedInstallationsAssignToCustomer.');
        }

        if (requestParameters.assignToCustomerRequestBody === null || requestParameters.assignToCustomerRequestBody === undefined) {
            throw new runtime.RequiredError('assignToCustomerRequestBody','Required parameter requestParameters.assignToCustomerRequestBody was null or undefined when calling unallocatedInstallationsAssignToCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installationId}/assignCustomer`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.assignToCustomerRequestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Assigns an unallocated installation to a specific customer by customer ID or email, moving it from the unallocated pool to customer installations. This action links all associated devices and gateways to the customer account
     * Assign Installation to Customer
     */
    async unallocatedInstallationsAssignToCustomer(requestParameters: UnallocatedInstallationsAssignToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GatewayResponseModel> {
        const response = await this.unallocatedInstallationsAssignToCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permanently removes an unallocated installation from the system. This action deletes the installation configuration and all associated device records. Cannot be undone. Used for cleaning up invalid or obsolete installation records
     * Remove Unallocated Installation
     */
    async unallocatedInstallationsDeleteInstallationRaw(requestParameters: UnallocatedInstallationsDeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling unallocatedInstallationsDeleteInstallation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installationId}`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently removes an unallocated installation from the system. This action deletes the installation configuration and all associated device records. Cannot be undone. Used for cleaning up invalid or obsolete installation records
     * Remove Unallocated Installation
     */
    async unallocatedInstallationsDeleteInstallation(requestParameters: UnallocatedInstallationsDeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unallocatedInstallationsDeleteInstallationRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves real-time telemetry data from a customer-assigned GridX device installation identified by site ID. Returns current energy metrics, device status, and sensor readings for monitoring operational performance post-assignment
     * Get Assigned Installation Live Data
     */
    async unallocatedInstallationsGetAllocatedLiveDataRaw(requestParameters: UnallocatedInstallationsGetAllocatedLiveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationLiveDataResponseModel>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling unallocatedInstallationsGetAllocatedLiveData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/assigned/{siteId}/live`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves real-time telemetry data from a customer-assigned GridX device installation identified by site ID. Returns current energy metrics, device status, and sensor readings for monitoring operational performance post-assignment
     * Get Assigned Installation Live Data
     */
    async unallocatedInstallationsGetAllocatedLiveData(requestParameters: UnallocatedInstallationsGetAllocatedLiveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationLiveDataResponseModel> {
        const response = await this.unallocatedInstallationsGetAllocatedLiveDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all IoT devices for a customer-assigned installation identified by site ID. Returns device configurations, types, serial numbers, and operational status for heat pumps, smart meters, PV systems, batteries, and other connected appliances
     * Get Assigned Installation Devices
     */
    async unallocatedInstallationsGetAssignedInstallationDevicesRaw(requestParameters: UnallocatedInstallationsGetAssignedInstallationDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedDeviceResponseModel>>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling unallocatedInstallationsGetAssignedInstallationDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/assigned/{siteId}/devices`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all IoT devices for a customer-assigned installation identified by site ID. Returns device configurations, types, serial numbers, and operational status for heat pumps, smart meters, PV systems, batteries, and other connected appliances
     * Get Assigned Installation Devices
     */
    async unallocatedInstallationsGetAssignedInstallationDevices(requestParameters: UnallocatedInstallationsGetAssignedInstallationDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedDeviceResponseModel>> {
        const response = await this.unallocatedInstallationsGetAssignedInstallationDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of installations that have been assigned to customers. Supports filtering by customer, tenant, vendor, and assignment date. Useful for tracking installation deployment history and customer allocations
     * Get Customer-Assigned Installations
     */
    async unallocatedInstallationsGetAssignedInstallationsRaw(requestParameters: UnallocatedInstallationsGetAssignedInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignedInstallationsResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.customerName !== undefined) {
            queryParameters['customerName'] = requestParameters.customerName;
        }

        if (requestParameters.customerEmail !== undefined) {
            queryParameters['customerEmail'] = requestParameters.customerEmail;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/assigned`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of installations that have been assigned to customers. Supports filtering by customer, tenant, vendor, and assignment date. Useful for tracking installation deployment history and customer allocations
     * Get Customer-Assigned Installations
     */
    async unallocatedInstallationsGetAssignedInstallations(requestParameters: UnallocatedInstallationsGetAssignedInstallationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignedInstallationsResponseModel> {
        const response = await this.unallocatedInstallationsGetAssignedInstallationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves real-time telemetry data from an unallocated GridX device installation. Returns current energy metrics, device status, and sensor readings for installation verification and testing. Useful for validating device connectivity before customer assignment
     * Get Installation Live Data
     */
    async unallocatedInstallationsGetLiveDataRaw(requestParameters: UnallocatedInstallationsGetLiveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationLiveDataResponseModel>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling unallocatedInstallationsGetLiveData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installationId}/live`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves real-time telemetry data from an unallocated GridX device installation. Returns current energy metrics, device status, and sensor readings for installation verification and testing. Useful for validating device connectivity before customer assignment
     * Get Installation Live Data
     */
    async unallocatedInstallationsGetLiveData(requestParameters: UnallocatedInstallationsGetLiveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationLiveDataResponseModel> {
        const response = await this.unallocatedInstallationsGetLiveDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all IoT devices associated with an unallocated installation. Returns device configurations, types, serial numbers, and connection status for heat pumps, smart meters, PV systems, batteries, and other connected appliances
     * Get Installation IoT Devices
     */
    async unallocatedInstallationsGetUnallocatedInstallationDevicesRaw(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UnallocatedDeviceResponseModel>>> {
        if (requestParameters.installation === null || requestParameters.installation === undefined) {
            throw new runtime.RequiredError('installation','Required parameter requestParameters.installation was null or undefined when calling unallocatedInstallationsGetUnallocatedInstallationDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installation}/devices`.replace(`{${"installation"}}`, encodeURIComponent(String(requestParameters.installation))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all IoT devices associated with an unallocated installation. Returns device configurations, types, serial numbers, and connection status for heat pumps, smart meters, PV systems, batteries, and other connected appliances
     * Get Installation IoT Devices
     */
    async unallocatedInstallationsGetUnallocatedInstallationDevices(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UnallocatedDeviceResponseModel>> {
        const response = await this.unallocatedInstallationsGetUnallocatedInstallationDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all gateway devices associated with an unallocated installation. Returns gateway configurations, connection status, firmware versions, and device communication protocols
     * Get Installation Gateway Devices
     */
    async unallocatedInstallationsGetUnallocatedInstallationGatewaysRaw(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationGatewaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UnallocatedGatewayResponseModel>>> {
        if (requestParameters.installation === null || requestParameters.installation === undefined) {
            throw new runtime.RequiredError('installation','Required parameter requestParameters.installation was null or undefined when calling unallocatedInstallationsGetUnallocatedInstallationGateways.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installation}/gateways`.replace(`{${"installation"}}`, encodeURIComponent(String(requestParameters.installation))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all gateway devices associated with an unallocated installation. Returns gateway configurations, connection status, firmware versions, and device communication protocols
     * Get Installation Gateway Devices
     */
    async unallocatedInstallationsGetUnallocatedInstallationGateways(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationGatewaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UnallocatedGatewayResponseModel>> {
        const response = await this.unallocatedInstallationsGetUnallocatedInstallationGatewaysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of installations that have not been assigned to any customer. Supports filtering by tenant, vendor, installation type, and date ranges. Essential for managing installation pool and tracking pending customer assignments
     * Get List of Unallocated Installations
     */
    async unallocatedInstallationsGetUnallocatedInstallationsRaw(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnallocatedInstallationsResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.startCode !== undefined) {
            queryParameters['startCode'] = requestParameters.startCode;
        }

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenantId'] = requestParameters.tenantId;
        }

        if (requestParameters.installerId !== undefined) {
            queryParameters['installerId'] = requestParameters.installerId;
        }

        if (requestParameters.installerCompanyId !== undefined) {
            queryParameters['installerCompanyId'] = requestParameters.installerCompanyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of installations that have not been assigned to any customer. Supports filtering by tenant, vendor, installation type, and date ranges. Essential for managing installation pool and tracking pending customer assignments
     * Get List of Unallocated Installations
     */
    async unallocatedInstallationsGetUnallocatedInstallations(requestParameters: UnallocatedInstallationsGetUnallocatedInstallationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnallocatedInstallationsResponseModel> {
        const response = await this.unallocatedInstallationsGetUnallocatedInstallationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiates a scan of the specified gateway to discover all connected IoT appliances. Returns list of detected devices including their types, serial numbers, and connection status. Used during installation setup to verify device connectivity
     * Scan Gateway for Connected Appliances
     */
    async unallocatedInstallationsScanGatewayDevicesRaw(requestParameters: UnallocatedInstallationsScanGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling unallocatedInstallationsScanGatewayDevices.');
        }

        if (requestParameters.gatewayId === null || requestParameters.gatewayId === undefined) {
            throw new runtime.RequiredError('gatewayId','Required parameter requestParameters.gatewayId was null or undefined when calling unallocatedInstallationsScanGatewayDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installationId}/gateway/{gatewayId}/scan`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"gatewayId"}}`, encodeURIComponent(String(requestParameters.gatewayId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Initiates a scan of the specified gateway to discover all connected IoT appliances. Returns list of detected devices including their types, serial numbers, and connection status. Used during installation setup to verify device connectivity
     * Scan Gateway for Connected Appliances
     */
    async unallocatedInstallationsScanGatewayDevices(requestParameters: UnallocatedInstallationsScanGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unallocatedInstallationsScanGatewayDevicesRaw(requestParameters, initOverrides);
    }

    /**
     * Updates configuration settings for a specific IoT device within an unallocated installation. Modifies device parameters, communication settings, and operational configurations. Used for pre-assignment device setup and testing
     * Update Device Configuration
     */
    async unallocatedInstallationsUpdateDeviceConfigurationRaw(requestParameters: UnallocatedInstallationsUpdateDeviceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnallocatedDeviceResponseModel>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling unallocatedInstallationsUpdateDeviceConfiguration.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unallocatedInstallationsUpdateDeviceConfiguration.');
        }

        if (requestParameters.unallocatedInstallationDeviceUpdateModel === null || requestParameters.unallocatedInstallationDeviceUpdateModel === undefined) {
            throw new runtime.RequiredError('unallocatedInstallationDeviceUpdateModel','Required parameter requestParameters.unallocatedInstallationDeviceUpdateModel was null or undefined when calling unallocatedInstallationsUpdateDeviceConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/unallocated-installations/{installationId}/devices/{id}`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unallocatedInstallationDeviceUpdateModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates configuration settings for a specific IoT device within an unallocated installation. Modifies device parameters, communication settings, and operational configurations. Used for pre-assignment device setup and testing
     * Update Device Configuration
     */
    async unallocatedInstallationsUpdateDeviceConfiguration(requestParameters: UnallocatedInstallationsUpdateDeviceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnallocatedDeviceResponseModel> {
        const response = await this.unallocatedInstallationsUpdateDeviceConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
